import {formatter, request} from '@/utils/request';

export namespace DeliveryLine {
  export const Path = {
    Query: '/expenseapi/deliveryLine/query',
    Search: '/expenseapi/deliveryLine/search',
    AjaxSearch: '/expenseapi/deliveryLine/ajaxSearch',
    Get: '/expenseapi/deliveryLine/get',
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.DeliveryLine>>(Path.Query, formatter(options),);
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.DeliveryLine>>(Path.Get, formatter(options));
  }

  export async function search(body: API.DeliveryLineFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.DeliveryLine[]>>(Path.Search, formatter(options));
  }

  export async function ajaxSearch(body: API.DeliveryLineFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.DeliveryLine[]>>(Path.AjaxSearch, formatter(options));
  }
}
